/**
 * Zendesk is off unless the deployment explicitly sets `NEXT_PUBLIC_ZENDESK_ENABLED=true`.
 * An unset variable, or the build placeholder left unsubstituted, keeps it off.
 */
export function isZendeskEnabled(raw: string | undefined): boolean {
  return raw?.trim().toLowerCase() === 'true';
}
